var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"size":_vm.size,"variant":"primary","block":_vm.block},on:{"click":_vm.handleClick}},[_c('feather-icon',{attrs:{"icon":"PlusCircleIcon","size":_vm.iconSize}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }